// Shared fetch + JSON-contract dispatch for the one-shot invest robot forms
// (Users::OneShotInvestRobotsController responses), used by both the legacy
// plan_investment_controller and the new_investment_flow one.

export async function submitInvestRobotForm(
  form,
  { onSuccess, onAlreadyExists = null, onInsufficientFunds = null, onError }
) {
  try {
    const response = await fetch(form.action, { method: form.method, body: new FormData(form) });
    const result = await response.json();

    if (response.ok) {
      onSuccess(result);
    } else if (onAlreadyExists && result.already_exists_for_project) {
      onAlreadyExists(result);
    } else if (onInsufficientFunds && result.insufficient_funds) {
      onInsufficientFunds(result);
    } else {
      onError(result);
    }
  } catch (error) {
    console.error(error);
    onError(null);
  }
}

export async function submitInvestRobotCancelForm(form, { onSuccess, onError }) {
  try {
    const response = await fetch(form.action, { method: form.method, body: new FormData(form) });

    if (response.ok) {
      onSuccess();
    } else {
      onError();
    }
  } catch (error) {
    console.error(error);
    onError();
  }
}
